import { useState } from 'react';
import memberPermissionService from '../services/member-permissions.service';
import api from '@/services/api';

export async function fetchNickname({ familyMemberId }: { familyMemberId: string }) {
  const res = await api.get('/member-permissions/nickname', {
    params: { familyMemberId }
  });
  return res.data.nickname;
}

import { familyService } from '@/services/family.service';

export function useMemberPermission(subjectId: string, familyId: string) {
  const [spouse, setSpouse] = useState<any>(null);

  // Fetch spouse and store in state
  const fetchSpouse = async () => {
    try {
      const data = await familyService.getSpouse();
      setSpouse(data && data.id ? data : null);
      return data && data.id ? data : null;
    } catch (err) {
      setSpouse(null);
      return null;
    }
  };
  const [invitedId, setInvitedId] = useState<string | null>(null);
  const [managedIds, setManagedIds] = useState<string[]>([]);
  const [tokens, setTokens] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  // Swap memberId and familyMemberId: memberId should be subjectId, familyMemberId should be member.id
  // isPet: if true, call acceptGrantAccess instead of inviteGrantAccess
  const handleGrantAccess = async (memberId: string, familyMemberId: string, skipConsent: boolean = false) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setSuccessMessage(null);
    setInvitedId(memberId);
    try {
      if (skipConsent) {
        await memberPermissionService.acceptGrantAccess({ memberId: familyMemberId, familyMemberId: memberId, familyId, skipTokenDelete: true });
      } else {
        await memberPermissionService.inviteGrantAccess({ memberId: familyMemberId, familyMemberId: memberId, familyId });
      }
      const { ids, tokens } = await memberPermissionService.getManagedMemberIdsAndTokens(subjectId);
      setManagedIds(ids);
      setTokens(tokens);
      setSuccess(true);
      setSuccessMessage('Invite sent successfully!');
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to send invite');
    } finally {
      setLoading(false);
      setInvitedId(null);
    }
  };


  // Revoke access handler
  const handleRevokeAccess = async (memberId: string, familyMemberId: string) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setSuccessMessage(null);
    setInvitedId(memberId);
    try {
      await memberPermissionService.revokeAccess({ memberId, familyId, familyMemberId });
      const { ids, tokens } = await memberPermissionService.getManagedMemberIdsAndTokens(subjectId);
      setManagedIds(ids);
      setTokens(tokens);
      setSuccess(true);
      setSuccessMessage('Access revoked successfully.');
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to revoke access');
    } finally {
      setLoading(false);
      setInvitedId(null);
    }
  };

  // Revoke invite handler
  const handleRevokeInvite = async (memberId: string, familyMemberId: string) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setSuccessMessage(null);
    setInvitedId(memberId);
    try {
      await memberPermissionService.revokeInvite({ memberId, familyId, familyMemberId });
      const { ids, tokens } = await memberPermissionService.getManagedMemberIdsAndTokens(subjectId);
      setManagedIds(ids);
      setTokens(tokens);
      setSuccess(true);
      setSuccessMessage('Invite revoked successfully.');
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to revoke invite');
    } finally {
      setLoading(false);
      setInvitedId(null);
    }
  };

  return {
    invitedId,
    managedIds,
    tokens,
    setManagedIds,
    setTokens,
    setInvitedId,
    handleGrantAccess,
    handleRevokeAccess,
    handleRevokeInvite,
    loading,
    error,
    success,
    successMessage,
    spouse,
    fetchSpouse,
    setSpouse,
  };
}
